import { render } from "./AdminSysDataTab.vue?vue&type=template&id=3707c241&ts=true"
import script from "./AdminSysDataTab.vue?vue&type=script&lang=ts"
export * from "./AdminSysDataTab.vue?vue&type=script&lang=ts"

import "./AdminSysDataTab.vue?vue&type=style&index=0&id=3707c241&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__